<template>
  <div class="cell" :class="{ 'cell-bold': !isBold }">
    <div>
      <span v-if="currency" class="d-contents">
        <span v-if="isSpan" class="currency">
          {{ currencySymbols[currency] }}
        </span>
        <template v-else> {{ currencySymbols[currency] }}&nbsp; </template>
      </span>
      {{ addSpaces(text) }}
    </div>
  </div>
</template>

<script>
  import addSpaces from '@/utils/formatting/add-spaces';
  import { mapState } from 'vuex';

  export default {
    name: 'CurrencyEntry',
    props: {
      isSpan: Boolean,
      isBold: Boolean,
      text: [String, Number],
      currency: {
        type: String,
        required: true,
      },
    },
    computed: {
      ...mapState('global', ['currencySymbols']),
    },
    methods: {
      addSpaces,
    },
  };
</script>
